// Generated by Melange

import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactCopyToClipboard from "react-copy-to-clipboard";
import * as JsxRuntime from "react/jsx-runtime";

function CopyButton24(Props) {
  let text = Props.text;
  const match = React.useState(function () {
    return false;
  });
  const setHovered = match[1];
  const match$1 = React.useState(function () {
    return false;
  });
  const setCopied = match$1[1];
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(ReactCopyToClipboard.CopyToClipboard, {
      text: text,
      onCopy: (function (param) {
        Curry._1(setCopied, (function (param) {
          return true;
        }));
        setTimeout((function (param) {
          Curry._1(setCopied, (function (param) {
            return false;
          }));
        }), 500);
      }),
      children: match$1[0] ? JsxRuntime.jsx("img", {
          className: "cursor-pointer w-6 h-6",
          src: StaticAsset.src("/static/icons/copy-check-24.svg")
        }) : (
          match[0] ? JsxRuntime.jsx("img", {
              className: "cursor-pointer w-6 h-6",
              src: StaticAsset.src("/static/icons/copy-black-24.svg")
            }) : JsxRuntime.jsx("img", {
              className: "cursor-pointer w-6 h-6",
              src: StaticAsset.src("/static/icons/copy-gray-24.svg")
            })
        )
    }),
    className: "hover:bg-gray-light rounded",
    title: "Скопировать",
    onClick: (function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }),
    onMouseEnter: (function (param) {
      Curry._1(setHovered, (function (param) {
        return true;
      }));
    }),
    onMouseLeave: (function (param) {
      Curry._1(setHovered, (function (param) {
        return false;
      }));
    })
  });
}

const timeout = 500;

const make = CopyButton24;

export {
  timeout,
  make,
}
/* react Not a pure module */
